import { render, staticRenderFns } from "./UserProfileWebpartTest.vue?vue&type=template&id=47a4bac4"
import script from "./UserProfileWebpartTest.vue?vue&type=script&lang=js"
export * from "./UserProfileWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports